<app-simple-modal [title]="'Prioridades'" [max]="80" [requiredFields]="false" (close)="close.emit($event)">
	<div fields>
		<div class="row">
			<div class="form-group col">
				<label for="warehouse" class="form-label">Bodega</label>
				<div class="input-group">
					<app-input-autocomplete (changeStatus)="selectWarehouse($event.filterElement)"
						(inputMethod)="writeWarehouse()" [allBorderRadius]="true"
						[filterElements]="warehouse.filterElements" [placeholder]="'Busca una bodega'"
						[inputs]="warehouse" (getTitle)="$event.filterElement.title = $event.filterElement.name">
					</app-input-autocomplete>
				</div>
			</div>
			<div class="form-group col">
				<label for="product" class="form-label">Producto</label>
				<div class="input-group">
					<app-loading-button tooltip="Guarda los productos agregados" placement="left"
						*ngIf="hasProductsAdded()" [logo]="true" [colorLoading]="'white'" [object]="buttonSave"
						(clicked)="savePriorities()"></app-loading-button>
					<app-input-autocomplete [ruleToDisabled]="!warehouse.data"
						(changeStatus)="selectProduct($event.filterElement)" (inputMethod)="writeProduct()"
						[allBorderRadius]="true" [allBorderRadius]="!hasProductsAdded()"
						[filterElements]="product.filterElements"
						[placeholder]="warehouse.data?'Selecciona productos para agregarlos':'Selecciona primero una bodega'"
						[inputs]="product" (getTitle)="$event.filterElement.title = $event.filterElement.name">
					</app-input-autocomplete>
				</div>
			</div>
		</div>
		<div *ngIf="warehouse.data">
			<table class="table">
				<thead>
					<tr class="tr-middle">
						<th colspan="4">
							Producto
						</th>
					</tr>
					<tr>
						<td>
							Barras
						</td>
						<td>
							Código
						</td>
						<td>
							Nombre
						</td>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let priority of priorities; let i = index" class="td-with-delete"
						[class.new-priority]="!priority.id"
					>
						<td>
							{{priority.product.barCode}}
						</td>
						<td>
							{{priority.product.code}}
						</td>
						<td>
							{{priority.product.name}}
							<div class="delete-container" [class.delete-active]="priority.showDelete">
								<i [ngClass]="priority.showDelete?' fa-caret-right':' fa-caret-left'"
									class="fa-solid"></i>
								<i *ngIf="!priority.showDelete" class="fa fa-trash item-hidden"
									(click)="showDeleteQuestion(priority, i)"></i>
								<div *ngIf="priority.showDelete" class="priority-delete">
									<ng-container *ngIf="!priority.deleting">
										<span>¿Estás seguro de eliminar la prioridad?</span>
										<i class="fa fa-trash clickeable" style="color: brown;"
											(click)="deletePriority(priority, i)"></i>
										<i class="fa fa-ban clickeable" style="color: var(--bs-bg-servicios);"
											(click)="priority.showDelete = false"></i>
									</ng-container>
									<ng-container *ngIf="priority.deleting">
										<app-loading-animation [height]="'1.5rem'"></app-loading-animation>
										<span style="color: var(--bs-bg-servicios);">Eliminando...</span>
									</ng-container>
								</div>
							</div>
						</td>
					</tr>
					<tr *ngIf="priorities.length == 0">
						<td colspan="3">
							La bodega aún no cuenta con productos que sean prioridad
						</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</app-simple-modal>